"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EEntityUpdateFlag = void 0;
/**
 * @public
 * Flags to indicate required state changes when entities change. Can be combined by bitwise OR.
 */
var EEntityUpdateFlag;
(function (EEntityUpdateFlag) {
    EEntityUpdateFlag[EEntityUpdateFlag["NoUpdateRequired"] = 0] = "NoUpdateRequired";
    EEntityUpdateFlag[EEntityUpdateFlag["DrawRequired"] = 1] = "DrawRequired";
    EEntityUpdateFlag[EEntityUpdateFlag["InteractionHandlerUpdateRequired"] = 2] = "InteractionHandlerUpdateRequired";
    EEntityUpdateFlag[EEntityUpdateFlag["UpdateAllRequired"] = 3] = "UpdateAllRequired";
})(EEntityUpdateFlag = exports.EEntityUpdateFlag || (exports.EEntityUpdateFlag = {}));
//# sourceMappingURL=e-entity-update-flag.js.map